/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.exportStand.ts
 *
 * Messages du chantier du 2026-10-04 : l'export CSV de l'écran « Mon stand »
 * est désormais fabriqué par le serveur (api/exhibitor/my-stand-export.php)
 * et emporte TOUS les passages, plus seulement les 20 derniers affichés.
 * Vocabulaire de l'événement par jetons, jamais en dur.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesExportStandFr: Record<string, string> = {
  'exportStand.aide':
    'Le fichier contient tous les passages enregistrés, pas seulement les derniers affichés ici.',
};
